import { BaseService } from "../../../../../core/services/base.service";
import { ClientId } from '../../company/models/clients.model';

export class JobClientsService {
  static async Get(companyId: string): Promise<ClientId[]> {
    return await BaseService.Get(`/companies/${companyId}/currencies`);
  }
  }